import { supabase } from '../lib/supabase';

export type ManageableUser={
  id:string;
  name:string;
  username:string|null;
  role:string;
  school_id:string|null;
  active:boolean;
  must_change_password?:boolean;
};

export type ClassOption={id:string;school_id:string;name:string;grade:number;shift:string|null;school_year:number;active:boolean};

function needClient(){if(!supabase)throw new Error('Supabase não configurado.');return supabase}

export async function loadManageableUsers(){
  const sb=needClient();
  const {data,error}=await sb.rpc('list_manageable_users');
  if(error)throw error;
  return (data||[]) as ManageableUser[];
}

export async function loadAdminClasses(schoolId:string){
  const sb=needClient();
  const {data,error}=await sb.from('classes').select('id,school_id,name,grade,shift,school_year,active').eq('school_id',schoolId).eq('active',true).order('grade').order('name');
  if(error)throw error;
  return (data||[]) as ClassOption[];
}

export async function loadTeacherPrimaryClass(userId:string){
  const sb=needClient();
  const {data,error}=await sb.from('teacher_classes').select('class_id').eq('teacher_id',userId).order('school_year',{ascending:false}).limit(1);
  if(error)throw error;
  return data?.[0]?.class_id||'';
}

export async function createRadarUser(payload:{name:string;username:string;role:string;school_id:string;class_id:string|null;password:string}){
  const sb=needClient();
  const {data,error}=await sb.functions.invoke('create-user',{body:payload});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data;
}

export async function updateRadarUser(payload:{user_id:string;name:string;username:string;role:string;school_id:string;class_id:string|null;active:boolean}){
  const sb=needClient();
  const {data,error}=await sb.functions.invoke('manage-user',{body:{action:'update',...payload}});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data;
}

export async function setRadarUserActive(userId:string,active:boolean){
  const sb=needClient();
  const {data,error}=await sb.functions.invoke('manage-user',{body:{action:'update_status',user_id:userId,active}});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data;
}

export async function deleteRadarUser(userId:string){
  const sb=needClient();
  const {data,error}=await sb.functions.invoke('manage-user',{body:{action:'delete',user_id:userId}});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data;
}

export async function resetRadarUserPassword(userId:string,password='1234'){
  const sb=needClient();
  const {data,error}=await sb.functions.invoke('reset-user-password',{body:{user_id:userId,password}});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data;
}
